export var getLanguage = function () { return getInitialI18n().lang || 'en'; };
export var getTranslations = function () { return getInitialI18n().localeData; };
function getInitialI18n() {
    return window.__INITIAL_I18N__ || {};
}
